export default __webpack_public_path__ + "static/media/search2Icon.0db7e187.svg";